// Firebase Configuration and Messaging Setup
import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDG9y5ZRhym3qIfm4JM-49Oe8sQOoODOTA",
  authDomain: "ggee-escola.firebaseapp.com",
  projectId: "ggee-escola",
  storageBucket: "ggee-escola.firebasestorage.app",
  messagingSenderId: "246692570786",
  appId: "1:246692570786:web:d9088250893e8e8fee59fb"
};

// Chave VAPID para Web Push
const VAPID_KEY = "BKGpjTa0Ra6WXaf5SBZEQ-owYytVFE2MFFCbZatPDgJMfNlGNbSBwN83sURYfXnzRJkffybhuvAUCib8v455GWU";

// Inicializar Firebase (singleton)
let app;
let messaging;

export function getFirebaseApp() {
  if (!app) {
    app = getApps()[0] || initializeApp(firebaseConfig);
  }
  return app;
}

export function getFirebaseMessaging() {
  if (!messaging && typeof window !== 'undefined' && 'Notification' in window) {
    const app = getFirebaseApp();
    messaging = getMessaging(app);
  }
  return messaging;
}

// Solicitar permissão e obter token FCM
export async function requestNotificationPermission() {
  try {
    // Verificar se o navegador suporta notificações
    if (!('Notification' in window)) {
      console.log('Este navegador não suporta notificações');
      return null;
    }

    // Verificar se já tem permissão
    if (Notification.permission === 'denied') {
      console.log('Notificações foram bloqueadas pelo usuário');
      return null;
    }

    // Solicitar permissão
    const permission = await Notification.requestPermission();
    
    if (permission !== 'granted') {
      console.log('Permissão de notificação não concedida');
      return null;
    }

    // Registrar service worker
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log('Service Worker registrado:', registration);

    // Obter token FCM
    const messaging = getFirebaseMessaging();
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    console.log('Token FCM obtido:', token);
    return token;
  } catch (error) {
    console.error('Erro ao obter token FCM:', error);
    return null;
  }
}

// Listener para mensagens em foreground (app aberto)
export function onForegroundMessage(callback) {
  const messaging = getFirebaseMessaging();
  if (messaging) {
    return onMessage(messaging, (payload) => {
      console.log('Mensagem recebida em foreground:', payload);
      callback(payload);
    });
  }
  return () => {};
}

export { VAPID_KEY };
